"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M13.42 0H.58A.58.58 0 000 .58V2.8c0 .18.09.36.24.47l4.74 3.4c.15.1.24.28.24.47v6.26c0 .48.56.76.94.45L8.4 12.5a.58.58 0 00.23-.46v-4.9c0-.17.08-.35.23-.46l4.92-3.73a.58.58 0 00.23-.46V.58a.58.58 0 00-.58-.58z"
}));

exports["default"] = _default;